// extracted by mini-css-extract-plugin
export default {"value":"PileLoadsSection_value__KUKz-","wrapper":"PileLoadsSection_wrapper__NYgrF"};